<mat-progress-bar *ngIf="inProgress" class="progress_bar" mode="buffer"></mat-progress-bar>
<div class="app">
  <header class="topbar">
    <div class="heading"><h1>Activités</h1><p>Suivez toutes les activités de votre projet</p></div>
    <div class="header-actions">
      <label class="search" aria-label="Rechercher"><span>⌕</span><input id="searchInput" type="search" placeholder="Rechercher une activité…"></label>
      <button class="primary-button" type="button"><span class="plus">＋</span><span class="button-label">Rechercher</span></button>
    </div>
  </header>

    <section class="kpis" aria-label="Indicateurs du mois">
        <article class="kpi"><div class="kpi-top"><span>Dépenses du mois</span><span class="kpi-icon">▣</span></div><div class="kpi-value">{{monthExpense}}</div><div class="kpi-note"><strong>{{totalExpense}}</strong> depuis Septembre passé</div></article>
        <article class="kpi"><div class="kpi-top"><span>Tâches en cours</span><span class="kpi-icon">☑</span></div><div class="kpi-value">{{tasksStats?.in_progress}}</div><div class="kpi-note">Sur <strong>{{tasksStats?.total_task}}</strong> tâches du mois</div></article>
        <article class="kpi"><div class="kpi-top"><span>Entrées du mois</span><span class="kpi-icon">↗</span></div><div class="kpi-value">{{monthSubscription}}</div><div class="kpi-note"><strong>{{totalSubscription}}</strong> depuis Septembre passé</div></article>
    </section>
    <section>
        <div fxLayout="row" fxLayout.xs="column">
            <div fxFlex="50%">
                <canvas class="activity-evolution"></canvas>
            </div>
            <div fxFlex="50%">
                
            </div>
        </div>
    </section>

    <section class="filters" aria-label="Filtres des activités">
        <div class="filter">
            <label for="expencesCategory">Catégorie</label>
            <mat-select id="expencesCategory" placeholder="Catégorie" [formControl]="categoriesControl" class="multiselect" multiple>
                <mat-option [value]="element['id']" *ngFor="let element of categories; let i = index">
                    <span class="mat-option-content">{{element['name_fr']}}</span>
                    <span class="mat-option-checkbox">
                        <mat-icon *ngIf="selectedElement(categoriesControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                    </span>
                </mat-option>
            </mat-select>
        </div>
        <div class="filter">
            <label for="expencesTaskCategory">Statut</label>
            <mat-select id="expencesTaskCategory" placeholder="Statut" [formControl]="statusControl" class="multiselect" multiple>
                <mat-option [value]="element['id']" *ngFor="let element of taskStatus.concat(expenseStatus); let i = index">
                    <span class="mat-option-content">{{ element['type'] == 'task_status' ? 'Tâche ' + element['name_fr']: 'Dépense ' + element['name_fr'] }}</span>
                    <span class="mat-option-checkbox">
                        <mat-icon *ngIf="selectedElement(statusControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                    </span>
                </mat-option>
            </mat-select>
        </div>
        <div class="filter">
            <label for="users">Responsables</label>
            <mat-select [formControl]="usersControl" multiple placeholder="Responsables">
                <mat-select-trigger>{{ selectedFilterUsers }}</mat-select-trigger>
                <input class="col-input-filter" [formControl]="userSearchControl">
                <mat-option *ngFor="let user of users" [value]="user.id">
                    <span class="option-user"><span class="avatar small-avatar" [style.background]="user.color || '#016F86'">{{ user.initials  }}</span><span><strong>{{ user.full_name }} <mat-icon *ngIf="selectedElement(usersControl, user)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon></strong><small>{{ user.email }} · {{ user.phone }}</small></span></span>
                </mat-option>
            </mat-select>
        </div>
        <div class="filter">
            <label for="projectFilter">Dates</label>
            <div id="categoryFilter" class="date-input">
                <mat-date-range-input [rangePicker]="picker1">
                    <input matStartDate [formControl]="startDateInputControl" placeholder="Start">
                    <input matEndDate [formControl]="endDateInputControl" placeholder="End">
                </mat-date-range-input>
                <mat-icon matDatepickerToggleIcon fontIcon="close_small" style="font-size: 18px; display: flex; align-items: center;" (click)="resetDate()"></mat-icon>
                <mat-datepicker-toggle [for]="picker1"></mat-datepicker-toggle>
                <mat-date-range-picker #picker1></mat-date-range-picker>
            </div>
        </div>
        <div class="class-mat-field" fxLayoutAlign="center center">
            <button class="button-secondary-small" (click) = "loadActivities()">Rafraichir</button>
        </div>
    </section>
    <div class="mobile-period">
        <div class="filter-mobile">
            <div class="filter">
                <div id="filterMobile" class="date-input">
                    <mat-date-range-input [rangePicker]="pickerFilterMobile">
                        <input matStartDate [formControl]="startDateInputControl" placeholder="Start">
                        <input matEndDate [formControl]="endDateInputControl" placeholder="End">
                    </mat-date-range-input>
                    <mat-icon matDatepickerToggleIcon fontIcon="close_small" (click)="resetDate()"></mat-icon>
                    <mat-datepicker-toggle [for]="pickerFilterMobile"></mat-datepicker-toggle>
                    <mat-date-range-picker #pickerFilterMobile></mat-date-range-picker>
                </div>
            </div>
        </div>
        <button type="button" class="btn-refresh" title="Actualiser" (click)="loadActivities()">
            <mat-icon>autorenew</mat-icon>
        </button>
    </div>
    <nav class="mobile-tabs" id="mobileTabs" aria-label="Type d'activité">
        <button class="mobile-tab active" data-target="expenses" type="button">Dépenses</button>
        <button class="mobile-tab" data-target="tasks" type="button">Tâches</button>
        <button class="mobile-tab" data-target="subscriptions" type="button">Entrées</button>
    </nav>

    <section class="activity-grid" id="activityGrid">
        <section class="activity-column mobile-active" id="expenses" aria-labelledby="expensesTitle">
            <header class="column-heading">
                <div class="column-title-wrap"><div class="column-icon expense">▣</div><div><h2 id="expensesTitle">Dépenses</h2><div class="column-subtitle">Total : <strong>{{expenseActivityAmount}}</strong> <span class="dot">·</span> {{expensesData.length}} dépenses</div></div></div>
                <button class="column-add" type="button" (click)="openActivity('expense')"><span>＋</span> Ajouter</button>
            </header>
            
            <div class="cards" style="max-height: 60vh; overflow: auto;">
                <article class="activity-card" data-category="Développement" data-people="JD SL" *ngFor="let element of expensesData; let i = index">
                    <div class="card-main">
                        <div class="activity-icon blue">🛒</div>
                        <div class="card-content">
                            <div class="card-title">{{element.title}}</div>
                            <div><span class="card-category">{{element.category}}</span><span class="dot">·</span><span class="card-objective">{{element.objective}}</span></div>
                            <div class="card-meta">
                                <span *ngIf="element.start_date != null" class="meta-item">▦ {{element.start_date}} – {{element.end_date}}</span>
                                <span *ngIf="element.pay_date != null" class="meta-item">☑ Payé le {{element.pay_date}}</span>
                                <span class="meta-item">{{element.coverage}}</span>
                            </div>
                        </div>
                        <div class="card-side"><div class="amount">{{element.amount_euro}} €</div><button class="more" aria-label="Actions" (click)="openActivity('expense', element)">⋮</button><span [ngClass]="['status', element.status_key]">{{element.status}}</span></div>
                    </div>
                    <div class="card-footer">
                        <div class="avatars">
                            <span class="avatar" [ngStyle]="{'background': element.user_assigned.color || '#016F86', 'color': '#fff'}">{{element.user_assigned.initials}}</span>
                        </div>
                        <span class="attachment" *ngIf="element.attachments?.length">📎 {{ element.attachments.length }}<span class="attachment-name">{{ element.attachments[0].name }}</span></span>
                    </div>
                </article>
            </div>
        </section>

        <section class="activity-column" id="tasks" aria-labelledby="tasksTitle">
            <header class="column-heading">
                <div class="column-title-wrap"><div class="column-icon task">☑</div><div><h2 id="tasksTitle">Tâches</h2><div class="column-subtitle">{{tasksData.length}} tâches <span class="dot">·</span> <span style="color:#d93350">{{taskInProgress}} en retard</span></div></div></div>
                <button class="column-add" type="button" (click)="openActivity('task')"><span>＋</span> Ajouter</button>
            </header>
            <div class="cards" style="max-height: 60vh; overflow: auto;">
                <article class="activity-card" data-category="Développement" data-people="JD SL" *ngFor="let element of tasksData; let i = index">
                    <div class="card-main">
                        <div class="activity-icon blue">☑</div>
                        <div class="card-content">
                            <div class="card-title">{{element.title}}</div>
                            <div><span class="card-category">{{element.category}}</span><span class="dot">·</span><span class="card-objective">{{element.objective}}</span></div>
                            <div *ngIf="element.start_date != null" class="card-meta"><span class="meta-item">▦ {{element.start_date}} – {{element.completed_date}}</span></div>
                        </div>
                        <div class="card-side"><button class="more" aria-label="Actions" (click)="openActivity('task', element)">⋮</button><span [ngClass]="['status', element.status_key]">{{element.status}}</span></div>
                    </div>
                    <div class="card-footer">
                        <div class="avatars">
                            <span *ngFor="let user of (element.users_assigned || []).slice(0, 2); let i = index" class="avatar" [ngStyle]="{'background': user.color || '#016F86', 'color': '#fff'}">{{user.initials}}</span>
                        </div>
                        <div class="progress-row">
                            <span *ngIf="(element.users_assigned || []).length > 2" style="color:var(--muted)">♧ {{ (element.users_assigned || []).length - 2 }}</span>
                            <div class="progress-track">
                                <div class="progress-fill" [style.width]="element.progress + '%'"></div>
                            </div>
                            <span class="progress-value">{{element.progress}}%</span>
                        </div>
                    </div>
                </article>
            </div>
        </section>

        <section class="activity-column" id="subscriptions" aria-labelledby="subscriptionsTitle">
            <header class="column-heading">
                <div class="column-title-wrap"><div class="column-icon subscription">↗</div><div><h2 id="subscriptionsTitle">Entrées</h2><div class="column-subtitle">Abonnements <span class="dot">·</span> <strong>{{subscriptionActivityAmount}}</strong></div></div></div>
                <button class="column-add" type="button"><span>＋</span> Ajouter</button>
            </header>
            <div class="cards" style="max-height: 60vh; overflow: auto;">
                <article class="activity-card" data-category="Abonnement" data-people="EVK" data-search="Abonnement Golden Etudiant Eleve TGO UL FDS Mathématique EVK026 FLOOZ_ECOM paiement 1 fois sur 4" *ngFor="let element of subscriptionData; let i = index">
                <div class="card-main">
                    <div class="activity-icon gold">↗</div>
                    <div class="card-content">
                        <div class="card-title">Abonnement {{element['product_name']}}</div>
                        <div><span class="card-category">{{element['product_name']}}</span><span class="dot">·</span><span class="card-objective">{{element['installment']}}</span></div>
                        <div class="card-meta"><span class="meta-item">▦ {{element['sub_activation_date']}} - {{element['sub_expiration_date']}}</span></div>
                    </div>
                    <div class="card-side">
                        <div class="amount">{{element['payment_price']}} {{element['payment_currency']}}</div>
                        <button class="more" aria-label="Actions abonnement">⋮</button><span class="status paid">Encaissé</span></div>
                    </div>
                <div class="subscription-details">
                    <div class="subscription-detail"><span>Profil</span><strong>{{element['profil']}}</strong></div>
                    <div class="subscription-detail"><span>Parent</span><strong>{{element['belongs']}}</strong></div>
                    <div class="subscription-detail"><span>Parcours</span><strong>{{element['student_study']}}</strong></div>
                    <div *ngIf="element.promo_code != null" class="subscription-detail"><span>Code promo</span><strong><span class="promo-code">{{element['promo_code']}}</span></strong></div>
                    <div class="subscription-detail"><span>Produit</span><strong>{{element['product_name']}} ({{element['installment']}})</strong></div>
                    <div class="subscription-detail"><span>Validité</span><strong>Du {{element['sub_activation_date']}} au {{element['sub_expiration_date']}}</strong></div>
                    <div class="subscription-detail"><span>Méthode de paiement</span><strong>{{element['payment_method']}}</strong></div>
                </div>
                <div class="card-footer"><div class="avatars"><span class="avatar">EV</span></div><span class="attachment">▤ <span>Informations d'abonnement</span></span></div>
                </article>
            </div>
        </section>
  </section>
</div>